import { CLEAR_TEMPORARY_SETTINGS, LOAD_TAB_SETTINGS } from "store/constans"

export const loadTabSettingsAC = ({currentTableId, colorScheme, columnSchemes}) => {
    return ({
        type: LOAD_TAB_SETTINGS,
        payload: {
            currentTableId,
            colorScheme: colorScheme,
            columnSchemes: columnSchemes,
        }
    })
}
export const clearTemporarySettingsAC = () => {
    return ({
        type: CLEAR_TEMPORARY_SETTINGS
    })
}